<template>
  <custom-popover
    :top="top"
    :left="left"
    class="edit-scope"
    @close="close"
  >
    <paper-simple class="mb-0">
      <div class="d-flex mb-1 justify-content-end">
        <a class="mr-auto">
          <GjIcon
            name="Edit"
            size="20"
          />
          Edit Scope
        </a>
        <a
          v-if="!somethingWrong"
          @click="update()"
        >
          <GjIcon name="Check" />
        </a>
        <a
          class="icon-right"
          @click="close"
        >
          <GjIcon name="Close" />
        </a>
      </div>
      <div v-if="somethingWrong">
        Something went wrong, please try again later.
      </div>
      <div
        v-else
        class="position-relative"
      >
        <loading-page
          v-if="gettingCertificate || updatingCertificate"
          class="position-absolute w-100 zindex-4"
          full
        />
        <custom-input-radio
          v-model="scopeId"
          class="mb-0"
          :class="{
            'opacity-7': gettingCertificate || updatingCertificate,
          }"
          :options="scopeOptions"
        />
      </div>
    </paper-simple>
  </custom-popover>
</template>
<script>
import CustomInputRadio from '@/components/form/CustomInputRadio.vue'
import CustomPopover from '@/components/popup/CustomPopover.vue'

export default {
  name: 'EditScope',
  components: { CustomInputRadio, CustomPopover },
  props: {
    somethingWrong: {
      type: Boolean,
      default: false,
    },
    tableRect: {
      type: DOMRect,
      default: null,
    },
    item: {
      type: Object,
      required: true,
    },
    rect: {
      type: DOMRect,
      default: null,
    },
  },
  data() {
    return {
      scopeId: 0,
    }
  },
  computed: {
    gettingCertificate() {
      return this.$store.state.cdn.gettingCertificate
    },
    certificate() {
      return this.$store.state.cdn.certificate
    },
    updatingCertificate() {
      return this.$store.state.cdn.updatingCertificate
    },
    scopeOptions() {
      return this.getObjectOptions(this.certificate.scopeOptions)
    },
    scope() {
      return this.scopeOptions.find(o => o.value === this.scopeId).text
    },
    top() {
      return this.rect.top
    },
    left() {
      return this.currentBreakPoint === 'xl' || this.currentBreakPoint === 'lg'
        ? this.rect.left - this.tableRect.left - 500
        : 0
    },
    currentBreakPoint() {
      return this.$store.getters['app/currentBreakPoint']
    },
  },
  created() {
    this.scopeId = this.certificate.scopeOptions[this.item.scope]
  },
  methods: {
    update() {
      this.$store
        .dispatch('cdn/updateCertificate', {
          id: this.item.id,
          scopeId: this.scopeId,
          scope: this.scope,
        })
        .then(() => {
          this.successToast('Scope was updated.')
          this.close()
        })
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors[0] || 'Something went wrong.',
          )
        })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.edit-scope {
  width: calc(100% - 20px);
  max-width: 500px;
}
</style>
